import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Table as CommonTable } from '../../../../../common/table'
import { getCellStyleByColId } from '../../common/helper'
import {
  getNoDataComponent,
  handleIconDownload,
  renderTd,
  sortKeySchemaTable,
} from '../../helper'
import classes from '../../index.module.scss'
import {
  selectByIdTable,
  selectCell,
  selectIdTable,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const Table = ({ isDynamicReport, id, checkTable }) => {
  let ids = useSelector(selectIdTable)
  const years = useSelector(selectYears)

  const tableSchema = {
    UNIT: 'unit',
    RATIO_NAME: 'ratioName',
  }
  years.forEach((year) => (tableSchema[String(year)] = String(year)))

  const isNoData = !years.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!years.length) {
    return getNoDataComponent(isDynamicReport)
  }

  if (isDynamicReport) {
    ids = ids.filter((id) => checkTable.includes(id))
  }

  return (
    <div className={classes.tablePanelContainer}>
      <CommonTable
        ids={ids}
        isDisplayScroll={!isDynamicReport}
        isNoStickyHead={isDynamicReport}
        getDataFromRedux={selectCell}
        schema={sortKeySchemaTable(Object.keys(tableSchema)).map((key) => {
          const title = `financialAnalysis.${key}`
          const colId = tableSchema[key]
          return {
            colId,
            title,
            disableSort: true,
            isI18n: true,
            ...getCellStyleByColId(colId),
            render: renderTd(selectByIdTable, selectIndicatorById),
          }
        })}
        autoHeightMax={300}
      />
    </div>
  )
}

export default Table
